var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpamAndBlockingNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Spam_Blocking_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spam_Blocking_Normal",
    "data-name": "Spam & Blocking_Normal",
    clipPath: "url(#clip-Spam_Blocking_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spam_Blocking",
    "data-name": "Spam & Blocking",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_67",
    "data-name": "Subtraction 67",
    d: "M-1403.831-783.93h-6.41a.685.685,0,0,1-.675-.694v-.017h-4.216v.017a.685.685,0,0,1-.675.694h-6.814a2.415,2.415,0,0,1-2.379-2.445v-4.578a1.99,1.99,0,0,1,.033-.451,8.613,8.613,0,0,1,8.4-7.145h6.679a8.346,8.346,0,0,1,1.916.223,6.393,6.393,0,0,0-.627,2.778,6.459,6.459,0,0,0,6.451,6.451,6.568,6.568,0,0,0,.694-.037v2.759A2.415,2.415,0,0,1-1403.831-783.93Z",
    transform: "translate(1425 813.368)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    transform: "translate(4.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4781",
    "data-name": "Path 4781",
    d: "M22.942,13.921A6.191,6.191,0,1,1,16.751,7.73,6.195,6.195,0,0,1,22.942,13.921Z",
    transform: "translate(-9.866 -7.036)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    d: "M17.045,21.1a6.885,6.885,0,1,1,6.885-6.885A6.891,6.891,0,0,1,17.045,21.1Zm0-12.382a5.5,5.5,0,1,0,5.5,5.5,5.5,5.5,0,0,0-5.5-5.5Z",
    transform: "translate(-10.16 -7.33)",
    fill: "#6f8b8f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(15.706 10.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    d: "M23.756,28.151a7.153,7.153,0,0,1-6.538-4.266,7.144,7.144,0,1,1,13.2-.295,7.054,7.054,0,0,1-3.781,3.954A7.27,7.27,0,0,1,23.756,28.151Zm-.017-12.885a5.68,5.68,0,0,0-2.307.486,5.749,5.749,0,0,0,.243,10.613,5.663,5.663,0,0,0,4.388-.1,5.754,5.754,0,0,0-2.341-11.012Z",
    transform: "translate(-16.609 -13.859)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(16.255 14.746)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y1: 5.203,
    x2: 11.793,
    transform: "translate(0.702 0.702)",
    fill: "#b4c164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    d: "M17.627,22.674a.719.719,0,0,1-.642-.416.692.692,0,0,1,.364-.919l11.793-5.2a.7.7,0,0,1,.555,1.283L17.9,22.621a.785.785,0,0,1-.277.052Z",
    transform: "translate(-16.925 -16.075)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M15.04,25.267h-.676a.694.694,0,1,1,0-1.387h.676a.694.694,0,0,1,0,1.387Z",
    transform: "translate(-2.659 4.171)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpamAndBlockingNormal);
export default __webpack_public_path__ + "static/media/Spam_And_Blocking_Normal.1906a23590c9da52e6cedb3666ec41c5.svg";
export { ForwardRef as ReactComponent };